import {ButtonsRow, HiveHeaderRow, HiveHeaderTabsWrapper} from 'features/hive/ui/HiveHeader/styles';
import {TabsGroup, TabsItem} from '@atomaro/ui-kit';
import {useLocation, useNavigate, useParams} from 'react-router-dom';
import {useMemo, useState} from 'react';
import Button from '@atomaro/ui-kit/components/Button/Button/Button';
import {AddLarge} from 'shared/ui/icons';
import {useDiaryStore} from 'entities/diary';
import {useResize} from '../../../../app/lib/hooks/useResize.ts';
import {CalendarNewEvent} from 'features/calendar/index.ts';
import {useHivesStore} from 'entities/hives/index.ts';
import {GeoIcon} from 'shared/ui/icons/geoIcon.tsx';
import {useCurrentHiveStore} from 'entities/currentHive';

export const HiveHeader = () => {
  const hives = useHivesStore((s) => s.hives);
  const {id} = useParams<{id: string}>();
  const location = useLocation();
  const navigate = useNavigate();
  const {isScreenLg} = useResize();

  const active = useMemo(
    () => (location.pathname.endsWith('/analytics') ? '1' : '0'),
    [location.pathname]
  );

  const isSmart = useCurrentHiveStore((s) => s.currentHive?.isSmart);
  const setIsNewEntrieOpen = useDiaryStore((s) => s.setIsNewEntrieOpen);
  // const setCurrentHive = useDiaryStore(s => s.editEntry())

  const [isNewEventOpen, setIsNewEventOpen] = useState<boolean>(false);

  console.log(isSmart);

  return (
    <HiveHeaderRow>
      <HiveHeaderTabsWrapper>
        <TabsGroup
          size="m"
          variant="primary"
          value={active}
          onChange={(val) => {
            if (val === '0') navigate(`/hive/${id}`);
            if (val === '1') navigate(`/hive/${id}/analytics`);
          }}
        >
          <TabsItem index="0" label="Сводка" />
          <TabsItem index="1" label="Аналитика" />
        </TabsGroup>
      </HiveHeaderTabsWrapper>
      {isScreenLg && (
        <ButtonsRow>
          <Button
            label="Новая запись"
            iconPrefix={<AddLarge />}
            style={{marginLeft: 'auto'}}
            onClick={() => setIsNewEntrieOpen(true)}
          />
          <Button
            label="Новое событие"
            iconPrefix={<AddLarge />}
            style={{marginLeft: 'auto'}}
            onClick={() => setIsNewEventOpen(true)}
          />

          {id && (
            <CalendarNewEvent
              isOpen={isNewEventOpen}
              onClose={() => setIsNewEventOpen(false)}
              defaultValues={{
                hiveIds: [id],
                hives: hives
                  .filter((el) => el.id === id)
                  .map((el) => ({key: el.id, value: `№${el.number}`})),
              }}
            />
          )}
        </ButtonsRow>
      )}
    </HiveHeaderRow>
  );
};
